
import React, { useEffect, useState } from 'react';
import Loader from "../../control-components/loader/loader";
import { Dialog} from '@progress/kendo-react-dialogs';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import NOTIFICATION_MESSAGE from '../../helper/notification-messages';
import { TaskService } from '../../services/taskService';
import TextAreaKendo from "../../control-components/text-area/text-area";
import { renderErrors } from "src/helper/error-message-helper";

const EditDiscussion = ({ onClose, selectedDiscussionId, selectedTaskId }) => {
    let [fields, setFields] = useState({ discussion: "", });
    const [, setErrors] = useState("");
    const [, setSettingError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedDiscussionId) {
            getDiscussionById()
        }
    }, []);

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!fields.discussion) {
            formIsValid = false;
            errors["discussion"] = "this field can't be blank.";
        }
        setErrors(errors);
        return formIsValid;
    };

    const getDiscussionById = async () => {
        setLoading(true)
        await TaskService.getDiscussionById(selectedDiscussionId)
            .then(result => {
                setFields({
                    ...fields,
                    discussion: result.resultData?.description,
                })
                setLoading(false)
            }).catch(error => {
                renderErrors(error.message)
                setLoading(false)
            });
    }

    const updateDiscussion = async () => {
        setLoading(true)
        await TaskService.updateDiscussion(fields.discussion, selectedTaskId, selectedDiscussionId)
            .then(result => {
                setLoading(false)
                NotificationManager.success(NOTIFICATION_MESSAGE.DISCUSSION_UPDATED)
                onClose({ "isUpdated": true });
            }).catch(error => {
                renderErrors(error)
                setLoading(false)
            });
    }

    const handleSubmit = () => {
        setSettingError(true);
        if (handleValidation()) {
            updateDiscussion()
        }
    }

    const handleChange = (e) => {
        const name = e.target.name;
        const textAreaValue = e.value
        setFields({
            ...fields,
            [name]: textAreaValue,
        });
    };

    return (
        <Dialog onClose={onClose} title={"Update Discussion"} className='dialog-modal small-dialog medium-modal update-modal width_90 blue_theme'>
            <div className='Service-accept edit-Service-popup'>
                <div className=" p-3">
                    <TextAreaKendo
                        txtValue={fields.discussion}
                        onChange={handleChange}
                        name="discussion"
                        label="Discussion"
                        rows="3"
                        className="textarea-description"
                        placeholder="Enter your Discussion Detail"
                    />
                </div>
                {
                    loading === true && <Loader />
                }
<div className='preview-btn-bottom ml-2'>
                <div className="row my-3 justify-content-end" >
                    <div className="d-flex  mr-3">
                        <div>
                            <button onClick={handleSubmit} className='submitButon' >
                                Save
                            </button>
                        </div>
                        <div>
                            <button className='cancelBtn' onClick={onClose}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </Dialog>
    );
}
export default EditDiscussion;



